import { httpService, path, storage } from '@commons';
import { CONFIG_SESSION } from '@handler/common/startSession';
import { toast } from 'react-toastify';

export const handleSSORedirect = async ({
  categoryItem,
  articleItem,
  openNewPage = true,
} = {}) => {
  try {
    const user = JSON.parse(storage.get(path.sessionUser));
    const currentSession = JSON.parse(storage.get(CONFIG_SESSION));
    const clienteAgrareId = currentSession?.contaAgrare?.id;
    const returnTo = articleItem?.url || categoryItem?.url || path.support;

    if (!user?.id) {
      toast.warn('Usuário não encontrado');
      return;
    }

    const payload = {
      clienteAgrareId,
      idUser: user.id,
      returnTo,
    };

    const ssoDTO = await httpService.postApiManager('/zendesk/sso', payload);
    const redirectUrl = `${ssoDTO.redirectUrl}&return_to=${encodeURIComponent(ssoDTO.returnTo)}`;

    window.open(
      redirectUrl,
      openNewPage ? '_blank' : '_self',
      'noopener,noreferrer',
    );
  } catch (error) {
    toast.error('Erro ao configurar SSO', {
      position: 'bottom-center',
    });
  }
};
